import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Skeleton from 'react-loading-skeleton';
import { useHistory, useLocation } from 'react-router-dom';
import { order as onOrder, orderCancelRequest } from '../../../../store/modules/order/actions';
import { StoreState } from '../../../../store/createStore';

import { routesEndpoints } from '../../../../routes/endpoint';
import { setIsCategory } from '../../../../store/modules/parameter/actions';
import InfoLocker from '../InfoLocker';
import PaymentConfirmation from '../../../../components/PaymentConfirmation';
import {
    Actions,
    BackBtn,
    CancelBtn,
    Container,
    ContainerInfo,
    ContainerTotals,
    Header,
    KeepBuyingBtn,
    Root,
    SubTitle,
    TextInfo,
    Title,
    TitleInfo,
    InfoLeft,
    ContainerProduct,
    ContainerImage,
    InfoProduct,
    PriceTotalProduct,
    ContainerInfoProduct,
    SubTitleInfo
} from './styles';
import { ProductData } from '../../../../store/modules/product/types';
import { formatQty } from '../../../../utils/formatyQtd';
import { RoundHelper } from '../../../../utils/roundHelper';

interface ProductSaleListProps {
    item: ProductData,
}

const ProductOrder: React.FC<ProductSaleListProps> = ({ item }: ProductSaleListProps) => {
    return <ContainerProduct>
        <ContainerImage>
            {<img src={item.product?.image_url} alt={item.short_description} />}
        </ContainerImage>
        <ContainerInfoProduct>
            <InfoProduct flexDirectionMobile='column' flex={1}>
                <TitleInfo>{item.short_description}</TitleInfo>
                <TextInfo>{item.product?.category?.short_description}</TextInfo>
            </InfoProduct>
            <InfoProduct align="center">
                <TitleInfo>QTD.:</TitleInfo>
                <TextInfo>{formatQty(item.qty_ordered?.toString() as string, item.product?.un)}</TextInfo>
            </InfoProduct>
            <InfoProduct>
                <PriceTotalProduct>{RoundHelper.toFormatted(item.grant_total)}</PriceTotalProduct>
            </InfoProduct>
        </ContainerInfoProduct>
    </ContainerProduct>
};

const OrderDetail: React.FC = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const orderId = queryParams.get('id');
    const { order, loading } = useSelector((state: StoreState) => state.order);
    const history = useHistory();
    const dispatch = useDispatch();
    const [showConfirm, setShowConfirm] = useState(false);
    useEffect(() => {
        dispatch(setIsCategory(false));
    }, [dispatch]);

    useEffect(() => {
        if (!order) {
            dispatch(onOrder(Number(orderId)));
        }
    }, [order, orderId, dispatch]);

    return (
        <Root>
            <Container>
                <Header>
                    <Title>
                        Pedido #{' '}
                        {loading ? (
                            <Skeleton duration={1} width={90} height={25} key="1" />
                        ) : (
                            order?.order_id
                        )}
                    </Title>
                    <SubTitle>RESUMO DO PEDIDO</SubTitle>
                    <p>Status do pedido: {order?.status_label}</p>
                </Header>

                <ContainerInfo>
                    {
                        loading && (
                            <>
                                <Skeleton duration={1} width="100%" height={120} key="2" />
                                <Skeleton duration={1} width="100%" height={120} key="3" />
                            </>
                        )
                    }
                    {order?.items && order.items.map(item => <ProductOrder item={item} key={item.order_item_id} />)}
                </ContainerInfo>

                <ContainerInfo>
                    <TitleInfo>Dados do pedido</TitleInfo>
                    <ContainerTotals>
                        <div>
                            <TextInfo>Subtotal</TextInfo>
                            <TextInfo>
                                {loading ? (
                                    <Skeleton duration={1} width={150} height={16} key="4" />
                                ) : (
                                    <>
                                        {RoundHelper.toFormatted(order?.sub_total)}
                                    </>
                                )}
                            </TextInfo>
                        </div>
                        <div>
                            <TextInfo>Frete</TextInfo>
                            <TextInfo>
                                {loading ? (
                                    <Skeleton duration={1} width={150} height={16} key="2" />
                                ) : (
                                    <>
                                        {Number(order?.shipping_amount || 0) > 0 ? (
                                            <>
                                                {RoundHelper.toFormatted(order?.shipping_amount)}
                                            </>
                                        ) : (
                                            <>
                                                Gratis
                                            </>
                                        )}
                                    </>

                                )}
                            </TextInfo>
                        </div>
                        {
                            order?.discount_amount && Number(order?.discount_amount) > 0 && (
                                <div>
                                    <TextInfo>Desconto</TextInfo>

                                    <TextInfo>

                                        {loading ? (
                                            <Skeleton duration={1} width={150} height={16} key="5" />
                                        ) : (
                                            <>
                                                {RoundHelper.toFormatted(order?.discount_amount)}
                                            </>
                                        )}
                                    </TextInfo>
                                </div>
                            )
                        }
                        <div>
                            <TextInfo>Total</TextInfo>

                            <TextInfo>
                                {loading ? (
                                    <Skeleton duration={1} width={150} height={16} key="6" />
                                ) : (
                                    <>
                                        {RoundHelper.toFormatted(order?.grand_total)}
                                    </>
                                )}
                            </TextInfo>
                        </div>
                    </ContainerTotals>
                </ContainerInfo>


                <ContainerInfo>
                    {
                        order?.locker ? (
                            <InfoLocker locker={order.locker} />
                        ) : (
                            <>
                                <TitleInfo>{order?.shipping_method === 'store' ?
                                    'Endereço de Retirada'
                                    : 'Endereço de Entrega'
                                }</TitleInfo>

                                <InfoLeft>
                                    <TextInfo>
                                        {loading ? (
                                            <Skeleton duration={1} width={250} height={16} key="7" />
                                        ) : (
                                            `${order?.shipping?.address}, ${order?.shipping?.number}`
                                        )}</TextInfo>
                                </InfoLeft>
                                <InfoLeft>
                                    <TextInfo>
                                        {loading ? (
                                            <Skeleton duration={1} width={250} height={16} key="8" />
                                        ) : (
                                            order?.shipping?.neighborhood
                                        )}
                                    </TextInfo>
                                </InfoLeft>
                                <InfoLeft>
                                    <TextInfo>
                                        {loading ? (
                                                <Skeleton duration={1} width={250} height={16} key="9" />
                                        ) : (
                                            ` ${order?.shipping?.city} - ${order?.shipping?.state}`
                                        )}
                                    </TextInfo>
                                </InfoLeft>
                                {
                                    order?.shipping_date && (
                                         <InfoLeft>
                                    <TextInfo>
                                        Agendamento:{' '}
                                        {
                                            new Date(order.shipping_date).toLocaleString("pt-BR", {
                                                weekday: "long",
                                                day: "2-digit",
                                                month: "long",
                                                year: "numeric",
                                                hour: "2-digit",
                                                minute: "2-digit",
                                            })
                                        }
                                    </TextInfo>
                                </InfoLeft>
                                    )
                                }

                            </>
                        )
                    }
                </ContainerInfo>

                {
                    order && order.payment_detail && order.payment_detail.length > 0 && order.payment_detail[0].method === 'cashondelivery' && (
                        <ContainerInfo>
                            <TitleInfo>{order?.shipping_method === 'store' ?
                                    'Modo de Pagamento: Na retirada'
                                    : 'Modo de Pagamento: Na entrega'
                                }</TitleInfo>
                            <SubTitleInfo color="#939393">{order.payment_detail[0].media_name}</SubTitleInfo>
                        </ContainerInfo>
                    )
                }

                <ContainerInfo>
                    {
                        loading ? (
                            <Skeleton duration={1} width="100%" height={120} key="10" />
                        ) : (
                            <>
                                <PaymentConfirmation order={order} isOrderPage={true} />
                            </>
                        )
                    }
                </ContainerInfo>
                {/*  */}

                <Actions>
                    <BackBtn onClick={() => history.goBack()}>
                        <span>Voltar</span>
                    </BackBtn>

                    {
                        ((order?.status as string) !== 'pending_payment' && (order?.status as string) !== 'pending' && (order?.status as string) !== 'canceled' && (order?.status as string) !== 'completed' && (order?.status as string) !== 'in_transit') && (
                            <CancelBtn
                                id="cancel-order"
                                onClick={() => setShowConfirm(true)}
                            >
                                <span>Cancelar pedido</span>
                            </CancelBtn>
                        )
                    }

                    <KeepBuyingBtn onClick={() => history.push(routesEndpoints.HOME)}>
                        <span>Continuar comprando</span>
                    </KeepBuyingBtn>
                </Actions>


            </Container>
            {showConfirm && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 1000,
                }}>
                    <div style={{
                        backgroundColor: '#fff',
                        padding: '20px',
                        borderRadius: '8px',
                        maxWidth: '400px',
                        width: '90%',
                        textAlign: 'center',
                    }}>
                        <p>Tem certeza que deseja cancelar este pedido?</p>
                        <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '20px' }}>
                            <button
                                onClick={() => setShowConfirm(false)}
                                style={{
                                    padding: '10px 20px',
                                    border: 'none',
                                    backgroundColor: '#424242',
                                    color: '#fff',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontWeight: 600,
                                    transition: 'background 0.2s ease',
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#303030'}
                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#424242'}
                            >
                                Cancelar
                            </button>
                            <button
                                id="cancel-order-confirm"
                                onClick={() => {
                                    if (order?.order_id) {
                                        dispatch(orderCancelRequest(order.order_id));
                                    }
                                    setShowConfirm(false);
                                }}
                                style={{
                                    padding: '10px 20px',
                                    border: 'none',
                                    backgroundColor: '#dc3545',
                                    color: '#fff',
                                    borderRadius: '4px',
                                    fontWeight: 600,
                                    cursor: 'pointer',
                                }}
                            >
                                Confirmar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </Root>
    );
};

export default OrderDetail;
